import { setDemoMode } from './demoMode';

/**
 * Shown on every admin surface while demo mode is active. The audience should never have to guess
 * whether the numbers on screen are real, and the presenter needs a way out from any page.
 */
export function DemoBanner() {
  return (
    <div
      role="status"
      className="mono"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '8px 14px',
        marginBottom: 16,
        background: '#2A1B12',
        color: '#FFD9A8',
        border: '1px solid var(--orange)',
        fontSize: 11,
        letterSpacing: '.12em',
      }}
    >
      <span aria-hidden="true">●</span>
      <span style={{ flex: 1 }}>TRYB DEMO — DANE PRZYKŁADOWE · ZMIANY WYŁĄCZONE</span>
      <button
        type="button"
        onClick={() => setDemoMode(false)}
        style={{
          background: 'var(--orange)',
          color: 'var(--ink)',
          border: 0,
          padding: '4px 10px',
          fontSize: 11,
          letterSpacing: '.1em',
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        WYŁĄCZ DEMO
      </button>
    </div>
  );
}
